
import useUtilities from '~/composable/useUtilities';

export default {
  props: {
    subscriptions: {
      type: Array,
      default: () => (null)
    }
  },
  setup () {
    const { formatPrice } = useUtilities()

    // ux requirement: preselect it if there is only one subscription
    let hasRun = false
    const preselect = (active, toggle, subscriptions) => {
      if (subscriptions.length === 1 && !active && !hasRun) {
        toggle()
        hasRun = true
      }
    }

    return {
      preselect,
      formatPrice
    }
  }
}
